// extracted by mini-css-extract-plugin
export var container = "_s4-0";
export var table = "_s4-2";
export var tableWrapper = "_s4-1";